var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-bg"},[_c('div',{attrs:{"id":"lottie"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@assets/images/logo.png"),"rel":"preload"}})])])
}]

export { render, staticRenderFns }